import Vue from 'vue'
import dayjs from 'dayjs'

Vue.filter('dayjsFormat', (value, format = 'YYYY/M/D HH:mm') => {
  return dayjs(value).format(format)
})
